import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/fr';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';
import './i18n';
import reportWebVitals from './reportWebVitals';
import { AppTheme } from './theme';

const TRACKING_ID = process.env.REACT_APP_GTAG;

if (TRACKING_ID) {
  ReactGA.initialize(TRACKING_ID);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ThemeProvider theme={AppTheme}>
    <CssBaseline />

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
      <App />
    </LocalizationProvider>
  </ThemeProvider>,
);

reportWebVitals();
